import ApiClientError from "../core/ApiClientError.js";
export function assertOneOfStatus(response, expectedStatus) {
    if (!expectedStatus.includes(response.status)) {
        throw ApiClientError.fromResponse(`Unexpected response status (expected ${expectedStatus}, got: ${response.status})`, {
            ...response,
            request: null,
        });
    }
}
export default assertOneOfStatus;
